import { createApiRef } from '@backstage/core-plugin-api';
import { WorkflowPhase } from './types';

export interface TerraformStack {
  module: string;
  environments: TerraformEnvironment[];
}

export interface TerraformEnvironment {
  name: string;
  latestRun?: TerraformRun;
  runs: TerraformRun[];
}

export interface TerraformRun {
  workflowName: string;
  namespace: string;
  uid: string;
  phase: WorkflowPhase;
  action: 'plan' | 'apply' | 'release';
  startedAt?: string;
  finishedAt?: string;
  commitSha?: string;
}

export interface TriggerTerraformOptions {
  module: string;
  environment: string;
  action: 'plan' | 'apply';
  parameters?: Record<string, string>;
}

export interface TerraformPipelinesApi {
  listStacks(): Promise<TerraformStack[]>;
  getStackRuns(module: string, environment?: string): Promise<TerraformRun[]>;
  triggerPlan(opts: TriggerTerraformOptions): Promise<{ namespace: string; name: string }>;
  triggerApply(opts: TriggerTerraformOptions): Promise<{ namespace: string; name: string }>;
}

export const terraformPipelinesApiRef = createApiRef<TerraformPipelinesApi>({
  id: 'plugin.terraform-pipelines.service',
});
